export const fallbackFlagsPreprod = {
  propertyPlnarService: true,
  autoRentalShopSearchSelection: true,
  autoPhotoUploadCCC: true,
  autoDrpSearchSelection: true,
  collabAnalyzeInvoice: false,
  collabTagInvoice: true,
  propertyEmergencyWaterRemovalServices: true,
  propertyEmergencyServices: true,
  apigeeVehicleApi: true,
  dcv2onafi: false,
  enableCommercialLinesClaims: false,
};
